import './style.css';
import { projects, posts, links } from './content.js';

// --- theme -----------------------------------------------------------------
// CSS follows prefers-color-scheme by default, so we only ever write an explicit
// override. That keeps the unstyled flash to the case where someone opted out.

const THEME_KEY = 'jdwright:theme';
const root = document.documentElement;

function applyTheme(theme) {
  if (theme) {
    root.dataset.theme = theme;
  } else {
    delete root.dataset.theme;
  }
  const icon = document.querySelector('[data-theme-icon]');
  if (icon) icon.textContent = resolvedTheme() === 'dark' ? '☀' : '☾';
}

function resolvedTheme() {
  if (root.dataset.theme) return root.dataset.theme;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

applyTheme(localStorage.getItem(THEME_KEY));

document.getElementById('theme-toggle')?.addEventListener('click', () => {
  const next = resolvedTheme() === 'dark' ? 'light' : 'dark';
  localStorage.setItem(THEME_KEY, next);
  applyTheme(next);
});

// --- projects --------------------------------------------------------------

const grid = document.getElementById('project-grid');
const filterBar = document.getElementById('filters');
const emptyNote = document.getElementById('empty');

const allTags = [...new Set(projects.flatMap((project) => project.tags))].sort();
let activeTag = null;

function projectCard(project) {
  const item = document.createElement('li');
  item.className = 'project';

  const heading = document.createElement('h3');
  if (project.href) {
    const link = document.createElement('a');
    link.href = project.href;
    link.textContent = project.title;
    link.rel = 'noopener';
    heading.append(link);
  } else {
    heading.textContent = project.title;
  }

  const blurb = document.createElement('p');
  blurb.textContent = project.blurb;

  const meta = document.createElement('ul');
  meta.className = 'tags';
  meta.append(
    ...project.tags.map((tag) => {
      const chip = document.createElement('li');
      chip.textContent = tag;
      return chip;
    }),
  );

  const year = document.createElement('span');
  year.className = 'year';
  year.textContent = project.year;

  item.append(year, heading, blurb, meta);
  return item;
}

function renderProjects() {
  const visible = activeTag
    ? projects.filter((project) => project.tags.includes(activeTag))
    : projects;

  grid.replaceChildren(...visible.map(projectCard));
  emptyNote.hidden = visible.length > 0;

  for (const button of filterBar.children) {
    const isActive = (button.dataset.tag || null) === activeTag;
    button.setAttribute('aria-pressed', String(isActive));
  }
}

function renderFilters() {
  const makeButton = (label, tag) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    if (tag) button.dataset.tag = tag;
    button.addEventListener('click', () => {
      activeTag = activeTag === tag ? null : tag;
      renderProjects();
    });
    return button;
  };

  filterBar.replaceChildren(
    makeButton('All', null),
    ...allTags.map((tag) => makeButton(tag, tag)),
  );
}

renderFilters();
renderProjects();

// --- writing ---------------------------------------------------------------

const dateFormat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' });

document.getElementById('post-list').replaceChildren(
  ...posts.map((post) => {
    const item = document.createElement('li');

    const time = document.createElement('time');
    // Parse as UTC so the month never slips backwards in western timezones.
    time.dateTime = post.date;
    time.textContent = dateFormat.format(new Date(`${post.date}T00:00:00Z`));

    const title = document.createElement('span');
    if (post.href) {
      const link = document.createElement('a');
      link.href = post.href;
      link.textContent = post.title;
      title.append(link);
    } else {
      title.textContent = post.title;
      title.classList.add('dim');
    }

    item.append(time, title);
    return item;
  }),
);

// --- contact ---------------------------------------------------------------

document.getElementById('links').replaceChildren(
  ...links.map((entry) => {
    const item = document.createElement('li');

    const label = document.createElement('span');
    label.className = 'label';
    label.textContent = entry.label;

    const link = document.createElement('a');
    link.href = entry.href;
    link.textContent = entry.value;
    link.rel = 'noopener';

    item.append(label, link);
    return item;
  }),
);

document.getElementById('year').textContent = new Date().getFullYear();
